const REPORT_SPINNER = ".calculation-report-notices";

export default class ReportSpinnerView {
  render(status) {
    if (status.pendingReports > 0) $(REPORT_SPINNER).removeClass("d-none");
    else $(REPORT_SPINNER).addClass("d-none");
  }

  isVisible() {
    return $(`${REPORT_SPINNER}:not(.d-none)`).length > 0;
  }
}
